// // src/components/cards/PostCard.tsx
// //
// // This is your new project's card (design system, layout, locked/PPV/gift
// // treatment) rewired to real data instead of the mock `useAppStore`. It
// // replaces BOTH the old `PostCard.tsx` and `FeedPost.tsx` — view tracking
// // is folded in here rather than living in a separate wrapper.
// //
// // What's live today: reactions, bookmark, comments, view tracking, poll
// // display, media (single or multiple files).
// // What's dormant until the backend ships the fields: locked/PPV unlock,
// // gifting, subscribe-gated content. The JSX for these already exists below
// // — they just won't render while `post.locked` / `post.price` are undefined.

// // src/components/cards/PostCard.tsx
// //
// // This is your new project's card (design system, layout, locked/PPV/gift
// // treatment) rewired to real data instead of the mock `useAppStore`. It
// // replaces BOTH the old `PostCard.tsx` and `FeedPost.tsx` — view tracking
// // is folded in here rather than living in a separate wrapper.
// //
// // What's live today: reactions, bookmark, comments, view tracking, poll
// // display, media (single or multiple files).
// // What's dormant until the backend ships the fields: locked/PPV unlock,
// // gifting, subscribe-gated content. The JSX for these already exists below
// // — they just won't render while `post.locked` / `post.price` are undefined.

// // src/components/cards/PostCard.tsx
// //
// // This is your new project's card (design system, layout, locked/PPV/gift
// // treatment) rewired to real data instead of the mock `useAppStore`. It
// // replaces BOTH the old `PostCard.tsx` and `FeedPost.tsx` — view tracking
// // is folded in here rather than living in a separate wrapper.
// //
// // What's live today: reactions, bookmark, comments, view tracking, poll
// // display, media (single or multiple files).
// // What's dormant until the backend ships the fields: locked/PPV unlock,
// // gifting, subscribe-gated content. The JSX for these already exists below
// // — they just won't render while `post.locked` / `post.price` are undefined.

// import { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Avatar, Icon, Loop, Menu, Photo, SIZES, Verified } from "@/lib/ui";
// import { useCustomMutation, useGetData } from "@/hooks/api/use-api";
// import { useQueryClient } from "@tanstack/react-query";
// import { useAppSelector } from "@/services/hook";
// import type { RootState } from "@/services/store";
// import { formatTimeAgo, isActivelySubscribed } from "@/utils/helper";
// import type { CreatorUser } from "@/utils/types";
// import {
//   mapContentToFeedPost,
//   type RawContent,
//   type FeedPost,
// } from "@/lib/adapters/content";
// import { useContentInteractions } from "@/hooks/useContentInteractions";
// import { MediaLightbox } from "./media-light-box";
// import { CommentComposer } from "./comment-composer";

// const MEDIA_H = 420;
// const LOCKED_H = 320;

// export function FollowBtn({ username }: { username: string }) {
//   const queryClient = useQueryClient();
//   const { userObject } = useAppSelector((s: RootState) => s.auth);

//   const { data, isLoading: subsLoading } = useGetData({
//     url: `subscriptions?page=0&size=20&subscriberEmail=${userObject?.email}`,
//     queryKey: ["GetSubscriptionsForViewer"],
//   });

//   const currentSub = isActivelySubscribed(
//     (data as { data?: { content?: CreatorUser[] } } | undefined)?.data
//       ?.content ?? [],
//     username,
//   );
//   const isSubscribed = currentSub ? currentSub.isActive : false;

//   const invalidate = () =>
//     queryClient.invalidateQueries({
//       queryKey: ["GetSubscriptionsForViewer"],
//       exact: false,
//     });

//   const subscribeMutation = useCustomMutation({
//     endpoint: `subscriptions/subscribe/${username}`,
//     successMessage: () => "Followed",
//     onSuccessCallback: invalidate,
//   });
//   const unsubscribeMutation = useCustomMutation({
//     method: "delete",
//     endpoint: `subscriptions/unsubscribe/${currentSub?.subscription?.publicId}`,
//     successMessage: () => "Unfollowed",
//     onSuccessCallback: invalidate,
//   });

//   const isPending =
//     subscribeMutation.isPending || unsubscribeMutation.isPending;

//   return (
//     <button
//       className={"btn btn-sm " + (isSubscribed ? "btn-ghost" : "btn-blue")}
//       onClick={(e) => {
//         e.stopPropagation();
//         isSubscribed
//           ? unsubscribeMutation.mutate({})
//           : subscribeMutation.mutate({});
//       }}
//       disabled={isPending || subsLoading}
//     >
//       {isSubscribed ? "Following" : "Follow"}
//     </button>
//   );
// }

// /** One media item — photo, or a silent autoplay-when-in-view preview for
//  *  video (Instagram-feed style). Clicking either kind opens the lightbox,
//  *  where video actually gets a real <video controls> element and multiple
//  *  items become a carousel — see MediaLightbox.tsx. */
// function MediaTile({
//   file,
//   height,
//   onOpen,
// }: {
//   file: FeedPost["media"][number];
//   height: number;
//   onOpen: () => void;
// }) {
//   const isVideo = file.isVideo;
//   return (
//     <div
//       onClick={onOpen}
//       style={{
//         height,
//         borderRadius: 14,
//         position: "relative",
//         overflow: "hidden",
//         cursor: "pointer",
//       }}
//     >
//       {isVideo ? (
//         <Loop src={file.url} poster={undefined} active radius={14} />
//       ) : (
//         <Photo sizes={SIZES.feedCard} src={file.url} alt="" radius={14} />
//       )}
//       {isVideo && (
//         <div className="row center" style={{ position: "absolute", inset: 0 }}>
//           <div
//             className="feature-ic"
//             style={{ width: 56, height: 56, background: "rgba(0,0,0,.42)" }}
//           >
//             <Icon n="play" s={24} c="#fff" fill="#fff" />
//           </div>
//         </div>
//       )}
//       {file.duration && (
//         <div
//           className="pill t12 onart"
//           style={{ position: "absolute", bottom: 10, right: 10 }}
//         >
//           {file.duration}
//         </div>
//       )}
//     </div>
//   );
// }

// /** 0..N media files. Single file = full-width block; multiple = a simple
//  *  grid — but unlike the old project, every tile in that grid opens the SAME
//  *  lightbox instance scoped to this post's whole media list, at the index
//  *  clicked, so you can carousel through the rest from wherever you started. */
// function PostMedia({ media }: { media: FeedPost["media"] }) {
//   const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
//   if (!media.length) return null;

//   return (
//     <>
//       {media.length === 1 ? (
//         <MediaTile
//           file={media[0]}
//           height={MEDIA_H}
//           onOpen={() => setLightboxIndex(0)}
//         />
//       ) : (
//         <div
//           className="grid"
//           style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}
//         >
//           {media.slice(0, 4).map((file, i) => (
//             <MediaTile
//               key={i}
//               file={file}
//               height={MEDIA_H / 2 - 3}
//               onOpen={() => setLightboxIndex(i)}
//             />
//           ))}
//         </div>
//       )}
//       {lightboxIndex !== null && (
//         <MediaLightbox
//           items={media}
//           startIndex={lightboxIndex}
//           onClose={() => setLightboxIndex(null)}
//         />
//       )}
//     </>
//   );
// }

// export function PostCard({ raw }: { raw: RawContent }) {
//   const navigate = useNavigate();
//   const { userObject } = useAppSelector((s: RootState) => s.auth);
//   const post = mapContentToFeedPost(raw, userObject?.email);
//   const { react, removeReaction, toggleBookmark, addComment, recordView } =
//     useContentInteractions(post.id, userObject?.email);

//   const mine = post.authorEmail === userObject?.email;
//   const isSub = false; // TODO: wire once subscription-per-post data exists; see FollowBtn for the query shape

//   const [showComments, setShowComments] = useState(false);
//   const [reportedLocally, setReportedLocally] = useState(false);

//   // View tracking, folded in from the old FeedPost wrapper.
//   const rootRef = useRef<HTMLDivElement>(null);
//   useEffect(() => {
//     if (!rootRef.current || post.raw.viewers?.includes(userObject?.email ?? ""))
//       return;
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
//           recordView();
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.5 },
//     );
//     observer.observe(rootRef.current);
//     return () => observer.disconnect();
//   }, []);

//   const menu = mine
//     ? [
//         {
//           ic: "x",
//           t: "Delete post",
//           danger: true,
//           fn: () => {
//             /* TODO: delete mutation */
//           },
//         },
//       ]
//     : [
//         {
//           ic: "bookmark",
//           t: post.isBookmarked
//             ? "Remove from collection"
//             : "Save to collection",
//           fn: toggleBookmark,
//         },
//         "-" as const,
//         // Mute/block/report have no backend endpoint in the sample payload yet.
//         // Left in place — wire each to a real mutation as the API grows.
//         reportedLocally
//           ? { ic: "flag", t: "Reported ✓", off: true }
//           : {
//               ic: "flag",
//               t: "Report post",
//               danger: true,
//               fn: () => setReportedLocally(true),
//             },
//       ];

//   return (
//     <div
//       className="card"
//       style={{ padding: 18 }}
//       ref={rootRef}
//       onClick={() => navigate(`/dashboard/${post.id}`)}
//     >
//       <div className="row between" onClick={(e) => e.stopPropagation()}>
//         <div className="row gap12">
//           <Avatar
//             name={post.who}
//             size={44}
//             ring={post.live ? "var(--coral)" : undefined}
//           />
//           <div className="col">
//             <div className="row gap6">
//               <span className="b7 t14 uname">{post.who}</span>
//               {post.verified && <Verified />}
//               {isSub && !mine && (
//                 <span
//                   className="tag"
//                   style={{
//                     padding: "1px 8px",
//                     fontSize: 10.5,
//                     color: "var(--blueL-ink)",
//                     border: "none",
//                   }}
//                 >
//                   Subscribed
//                 </span>
//               )}
//             </div>
//             <div className="muted t13">
//               @{post.handle} · {formatTimeAgo(post.createdAt)}
//             </div>
//           </div>
//         </div>
//         <div className="row gap8">
//           {!mine && <FollowBtn username={post.handle} />}
//           <Menu items={menu} />
//         </div>
//       </div>

//       {post.text && (
//         <div
//           className="t14"
//           style={{ margin: "13px 0", lineHeight: 1.55 }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           {post.text}
//         </div>
//       )}

//       <div onClick={(e) => e.stopPropagation()}>
//         {/* Locked / PPV — dormant until `visibility`/`price` exist on the payload. */}
//         {post.locked ? (
//           <div className="locked" style={{ height: LOCKED_H }}>
//             <Photo
//               sizes={SIZES.feedCard}
//               src={post.media[0]?.url}
//               blur={10}
//               scale={1.12}
//             />
//             <div className="lockcover">
//               <div
//                 className="feature-ic"
//                 style={{ background: "rgba(37,153,246,.16)" }}
//               >
//                 <Icon n="lock" c="var(--blueL)" />
//               </div>
//               <div className="b7" style={{ color: "#fff" }}>
//                 {isSub ? "Pay-per-view drop" : "Exclusive locked content"}
//               </div>
//               <div className="row gap8">
//                 {!isSub && (
//                   <button className="btn btn-ghost btn-sm">Subscribe</button>
//                 )}
//                 <button className="btn btn-blue btn-sm">
//                   Unlock · {post.price} coins
//                 </button>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <PostMedia media={post.media} />
//         )}

//         {post.poll && (
//           <div className="col gap8" style={{ marginBottom: 4, marginTop: 12 }}>
//             {post.poll.map((o, i) => (
//               <div
//                 key={i}
//                 className="hair"
//                 style={{
//                   position: "relative",
//                   padding: "11px 14px",
//                   borderRadius: 12,
//                   overflow: "hidden",
//                   borderColor:
//                     post.pollVotedIndex === i
//                       ? "var(--blue-ink)"
//                       : "var(--line)",
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "absolute",
//                     left: 0,
//                     top: 0,
//                     bottom: 0,
//                     width: `${o.pct}%`,
//                     background:
//                       post.pollVotedIndex === i
//                         ? "rgba(37,153,246,.3)"
//                         : "rgba(37,153,246,.14)",
//                   }}
//                 />
//                 <div className="row between" style={{ position: "relative" }}>
//                   <span className="row gap8 b6 t14">
//                     {post.pollVotedIndex === i && (
//                       <Icon n="check" s={14} c="var(--blueL-ink)" />
//                     )}
//                     {o.label}
//                   </span>
//                   <span className="muted t13">{o.pct}%</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       <div
//         className="row between postbar"
//         style={{ marginTop: 14 }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="row gap20 postacts">
//           <button
//             className="row gap6 muted"
//             onClick={() =>
//               post.myReaction === "LIKE" ? removeReaction() : react("LIKE")
//             }
//             style={{
//               color: post.myReaction === "LIKE" ? "var(--coral-ink)" : "",
//             }}
//           >
//             <Icon
//               n="heart"
//               s={19}
//               fill={post.myReaction === "LIKE" ? "var(--coral-ink)" : undefined}
//             />
//             {post.counts.reactions}
//           </button>
//           <button
//             className="row gap6 muted"
//             onClick={() => setShowComments((v) => !v)}
//             style={{ color: showComments ? "var(--blueL-ink)" : "" }}
//           >
//             <Icon n="comment" s={19} />
//             {post.counts.comments}
//           </button>
//         </div>
//         {!mine && (
//           <button className="btn btn-ghost btn-sm">
//             <Icon n="gift" s={15} />
//             Gift
//           </button>
//         )}
//       </div>

//       {showComments && (
//         <div
//           style={{
//             marginTop: 14,
//             borderTop: "1px solid var(--line)",
//             paddingTop: 12,
//           }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           {post.comments.map((c) => (
//             <div
//               key={c.id}
//               className="row gap10"
//               style={{ padding: "7px 0", alignItems: "flex-start" }}
//             >
//               <Avatar name={c.mine ? "You" : c.authorEmail} size={30} />
//               <div className="col">
//                 <span className="t13">
//                   <b className="uname">
//                     {c.mine ? "You" : c.authorEmail.split("@")[0]}
//                   </b>
//                 </span>
//                 <span className="t14">{c.text}</span>
//               </div>
//             </div>
//           ))}
//           <CommentComposer onSubmit={addComment} />
//         </div>
//       )}
//     </div>
//   );
// }

// src/components/cards/PostCard.tsx
//
// This is your new project's card (design system, layout, locked/PPV/gift
// treatment) rewired to real data instead of the mock `useAppStore`. It
// replaces BOTH the old `PostCard.tsx` and `FeedPost.tsx` — view tracking
// is folded in here rather than living in a separate wrapper.
//
// What's live today: reactions, bookmark, comments, view tracking, poll
// display, media (single or multiple files).
// What's dormant until the backend ships the fields: locked/PPV unlock,
// gifting, subscribe-gated content. The JSX for these already exists below
// — they just won't render while `post.locked` / `post.price` are undefined.

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CREATORS, byHandle, useAppStore } from "@/lib/core";
import type { Post } from "@/lib/core";
import { Avatar, Icon, Loop, Menu, Photo, SIZES, Verified } from "@/lib/ui";
import { useCustomMutation } from "@/hooks/api/use-api";
import { useQueryClient } from "@tanstack/react-query";
import { useAppSelector } from "@/services/hook";
import type { RootState } from "@/services/store";
import { formatTimeAgo } from "@/utils/helper"; // port this one util over from the old project
import {
  mapContentToFeedPost,
  type RawContent,
  type FeedPost,
} from "@/lib/adapters/content";
import {
  useContentInteractions,
  useDeletePost,
  usePollVote,
} from "@/hooks/useContentInteractions";
import { useSubscriptionStatus } from "@/hooks/useSubscriptionStatus";
import { useFollowStatus } from "@/hooks/useFollowStatus";

import type { ReactionType } from "@/utils/types";
import { MediaLightbox } from "./media-light-box";
import { MediaExtras } from "./media-extras";
import { MentionText } from "./MentionText";
import { ReactionButton } from "./reaction-button";
import { CommentComposer } from "./comment-composer";
import { EditPostDialog } from "./edit-post-dialog";
import { ConfirmDialog } from "./confirm-dialog";

const MEDIA_H = 420;
const LOCKED_H = 320;

export function FollowBtn({ username }: { username: string }) {
  const queryClient = useQueryClient();
  // Real-ified against the newly-added follow endpoints — previously this
  // called subscriptions/subscribe+unsubscribe (the PAID tier flow) as a
  // stand-in, since no free "follow" endpoint existed yet. That's a
  // different relationship from the "Subscribed" tag on posts, which still
  // uses useSubscriptionStatus independently and is untouched by this.
  const { isFollowing, isLoading: followLoading } = useFollowStatus(username);

  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["GetFollowing"],
      exact: false,
    });

  const followMutation = useCustomMutation({
    endpoint: `subscriptions/follow/${username}`,
    successMessage: () => "Followed",
    onSuccessCallback: invalidate,
  });
  const unfollowMutation = useCustomMutation({
    method: "delete",
    endpoint: `subscriptions/unfollow/${username}`,
    successMessage: () => "Unfollowed",
    onSuccessCallback: invalidate,
  });

  const isPending = followMutation.isPending || unfollowMutation.isPending;

  return (
    <button
      className={"btn btn-sm " + (isFollowing ? "btn-ghost" : "btn-blue")}
      onClick={(e) => {
        e.stopPropagation();
        isFollowing ? unfollowMutation.mutate({}) : followMutation.mutate({});
      }}
      disabled={isPending || followLoading}
    >
      {isFollowing ? "Following" : "Follow"}
    </button>
  );
}

/** One media item — photo, or a silent autoplay-when-in-view preview for
 *  video (Instagram-feed style). Clicking either kind opens the lightbox,
 *  where video actually gets a real <video controls> element and multiple
 *  items become a carousel — see MediaLightbox.tsx. */
function MediaTile({
  file,
  height,
  onOpen,
}: {
  file: FeedPost["media"][number];
  height: number;
  onOpen: () => void;
}) {
  const isVideo = file.isVideo;
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={isVideo ? "Play video" : "View photo"}
      style={{
        height,
        width: "100%",
        display: "block",
        padding: 0,
        borderRadius: 14,
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
      }}
    >
      {isVideo ? (
        <Loop src={file.url} poster={undefined} active radius={14} />
      ) : (
        <Photo sizes={SIZES.feedCard} src={file.url} alt="" radius={14} />
      )}
      {isVideo && (
        <div className="row center" style={{ position: "absolute", inset: 0 }}>
          <div
            className="feature-ic"
            style={{ width: 56, height: 56, background: "rgba(0,0,0,.42)" }}
          >
            <Icon n="play" s={24} c="#fff" fill="#fff" />
          </div>
        </div>
      )}
      {file.duration && (
        <div
          className="pill t12 onart"
          style={{ position: "absolute", bottom: 10, right: 10 }}
        >
          {file.duration}
        </div>
      )}
    </button>
  );
}

/** 0..N media files. Photos/videos become tiles (one = full width, several =
 *  a grid); audio and documents render as a player / link underneath, since
 *  neither can be drawn as an image tile. Every tile opens the SAME lightbox,
 *  scoped to this post's visual media, at the index clicked — so you can
 *  carousel through the rest from wherever you started. */
function PostMedia({ media }: { media: FeedPost["media"] }) {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  if (!media.length) return null;

  const visual = media.filter((m) => m.isVisual);
  const extras = media.filter((m) => !m.isVisual);

  return (
    <>
      {visual.length === 1 && (
        <MediaTile
          file={visual[0]}
          height={MEDIA_H}
          onOpen={() => setLightboxIndex(0)}
        />
      )}
      {visual.length > 1 && (
        <div
          className="grid"
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}
        >
          {visual.slice(0, 4).map((file, i) => (
            <MediaTile
              key={i}
              file={file}
              height={MEDIA_H / 2 - 3}
              onOpen={() => setLightboxIndex(i)}
            />
          ))}
        </div>
      )}
      {extras.length > 0 && (
        <div style={{ marginTop: visual.length ? 10 : 0 }}>
          <MediaExtras media={extras} />
        </div>
      )}
      {lightboxIndex !== null && (
        <MediaLightbox
          items={visual}
          startIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </>
  );
}

/** The mock modals (gift, subscribe) expect a mock `Creator`. `byHandle()`
 *  falls back to CREATORS[0] for any creator it doesn't know — which is every
 *  real creator — so passing it straight through would send a gift to the WRONG
 *  person. Start from whatever it returns (so the modal still gets every field
 *  it expects) and overwrite the identity with the post's real author. */
export function creatorForModal(post: FeedPost) {
  const base = byHandle(post.handle);
  const known = base.handle === post.handle;
  return {
    ...base,
    id: known ? base.id : post.handle,
    handle: post.handle,
    name: post.who,
  };
}

/** The report / PPV modals were written against the mock `Post` shape. */
export function legacyPost(post: FeedPost, mine: boolean): Post {
  return {
    id: post.id,
    h: post.handle,
    who: post.who,
    v: post.verified,
    t: formatTimeAgo(post.createdAt),
    text: post.text ?? "",
    type: post.locked
      ? "locked"
      : post.media.length
        ? post.media[0].isVideo
          ? "video"
          : "image"
        : "text",
    mine,
    likes: post.counts.reactions,
    comments: post.counts.comments,
    price: post.price ?? 0,
    seed: post.id,
  } as unknown as Post;
}

/** Where a post's detail page lives: `feed/:id`
 *  (`<Route path="feed/:id" element={<PostDetailPage />} />`). It's the only
 *  place the path is written — the card click, "Copy link" and the back
 *  button all read it from here. */
export const postPath = (id: string) => `/feed/${id}`;

/** Same wording as the old AnsweredPoll: "3d left" / "4h 26min left" /
 *  "12min left" / "Poll ended". */
function pollStatus(expiresAt: string | null, closed: boolean): string {
  if (closed) return "Poll ended";
  if (!expiresAt) return "";
  const ms = Date.parse(expiresAt) - Date.now();
  if (ms <= 0) return "Poll ended";
  const hours = Math.floor(ms / 3_600_000);
  const mins = Math.floor((ms % 3_600_000) / 60_000);
  if (hours >= 24) return `${Math.floor(hours / 24)}d left`;
  return hours > 0 ? `${hours}h ${mins}min left` : `${mins}min left`;
}

export function PostCard({
  raw,
  variant = "feed",
  isAlreadyBookmarked,
}: {
  raw: RawContent;
  /** The Bookmarks page knows every post it lists is bookmarked, but the post
   *  arrives nested inside a save record without a reliable `bookmarkers` list
   *  — so it says so explicitly (the old FeedPost took the same prop). */
  isAlreadyBookmarked?: boolean;
  /** "detail" = the post's own page: the card doesn't navigate to itself, and
   *  the comment thread below it replaces the inline comments panel. */
  variant?: "feed" | "detail";
}) {
  const navigate = useNavigate();
  const S = useAppStore();
  const queryClient = useQueryClient();
  const { userObject } = useAppSelector((s: RootState) => s.auth);
  const post = mapContentToFeedPost(raw, userObject?.email);
  const { react, removeReaction, toggleBookmark, addComment, recordView } =
    useContentInteractions(post.id, userObject?.email);

  const mine = post.authorEmail === userObject?.email;
  // "Subscribed" comes from the real subscriptions API (shared with FollowBtn);
  // PPV unlock is still the local store's.
  const { isSubscribed: isSub } = useSubscriptionStatus(post.handle);
  const isBookmarked = isAlreadyBookmarked ?? post.isBookmarked;
  const isUnlocked = !!S.unlocked[post.id];
  // The locked-post "Subscribe" button used to open the still-mock
  // SubscribeModal (S.subscribe — local store only, no real request) via
  // creatorForModal's legacy adapter. Locking content for real off a real
  // accessType field and then offering a fake way to unlock it would make
  // the whole feature decorative, so this calls the real paid-subscribe
  // endpoint directly instead — same one the (dead, commented-out) FollowBtn
  // subscribe path and subscriptions.tsx's "Resubscribe" already proved
  // works, just without a plan picker since there's only ever one real
  // price (creatorProfile.monthlyFee), not the old mock's fabricated
  // 3/12-month multipliers.
  const subscribeMutation = useCustomMutation({
    endpoint: `subscriptions/subscribe/${post.handle}`,
    successMessage: () => `Subscribed to @${post.handle}`,
    onSuccessCallback: () =>
      queryClient.invalidateQueries({
        queryKey: ["GetSubscriptionsForViewer"],
        exact: false,
      }),
  });
  // A creator is live if the backend says so (not sent yet) or the mock
  // directory does. NOT byHandle(): its CREATORS[0] fallback would make every
  // real post look live.
  const isLive =
    post.live || CREATORS.some((c) => c.handle === post.handle && c.live);

  const [showComments, setShowComments] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [editing, setEditing] = useState(false);
  const { deletePost, isDeleting } = useDeletePost(post.id, () => {
    setConfirmDelete(false);
    if (variant === "detail") navigate("/feed"); // the page we're on no longer exists
  });

  // Polls: pick an option, then press Vote. The vote request's URL contains the
  // chosen option's id, so the hook is handed the current selection.
  const [selectedChoice, setSelectedChoice] = useState<string | null>(null);
  const { vote, isVoting } = usePollVote(
    post.id,
    selectedChoice ?? "",
    userObject?.email,
  );
  const showPollResults = post.pollVotedIndex !== null || post.pollClosed;
  const pollTimeLeft = pollStatus(post.pollExpiresAt, post.pollClosed);

  // View tracking, folded in from the old FeedPost wrapper.
  const rootRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!rootRef.current || post.raw.viewers?.includes(userObject?.email ?? ""))
      return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          recordView();
          observer.disconnect();
        }
      },
      { threshold: 0.5 },
    );
    observer.observe(rootRef.current);
    return () => observer.disconnect();
  }, []);

  const copyLink = async () => {
    const url = `${window.location.origin}${postPath(post.id)}`;
    try {
      await navigator.clipboard.writeText(url);
      S.toast(`Link copied — ${url.replace(/^https?:\/\//, "")}`, "ok");
    } catch {
      S.toast("Failed to copy link", "err");
    }
  };

  // Bookmark, edit, delete and copy-link are real (API / clipboard); the rest are
  // the store's own local actions — none has a backend endpoint yet.
  const menu = mine
    ? [
        { ic: "repost", t: "Copy link", fn: copyLink },
        // Same order as the old TimeLineHomeModal: copy link, edit, delete.
        // (`edit` is a guess at your icon name — swap it if it's called something else.)
        { ic: "edit", t: "Edit post", fn: () => setEditing(true) },
        "-" as const,
        {
          ic: "x",
          t: "Delete post",
          danger: true,
          fn: () => setConfirmDelete(true),
        },
      ]
    : [
        {
          ic: "bookmark",
          t: isBookmarked ? "Remove from collection" : "Save to collection",
          fn: () => toggleBookmark(isBookmarked),
        },
        { ic: "repost", t: "Copy link", fn: copyLink },
        "-" as const,
        { ic: "eye", t: "Not interested", fn: () => S.hide(post.id) },
        {
          ic: "bell",
          t: `Mute @${post.handle}`,
          fn: () => S.mute(post.handle),
        },
        {
          ic: "shield",
          t: `Block @${post.handle}`,
          danger: true,
          fn: () => S.block(post.handle),
        },
        S.reported[post.id]
          ? { ic: "flag", t: "Reported ✓", off: true }
          : {
              ic: "flag",
              t: "Report post",
              danger: true,
              fn: () => S.openModal("report", post),
            },
      ];

  return (
    <div
      className="card"
      style={{ padding: 18 }}
      ref={rootRef}
      onClick={
        variant === "feed" ? () => navigate(postPath(post.id)) : undefined
      }
    >
      <div className="row between" onClick={(e) => e.stopPropagation()}>
        <div className="row gap12">
          <Avatar
            name={post.who}
            src={post.avatar}
            size={44}
            ring={isLive ? "var(--coral)" : undefined}
            onClick={
              isLive ? () => navigate(`/live/${post.handle}`) : undefined
            }
            initialsOnly
          />
          <div className="col">
            <div className="row gap6">
              <span className="b7 t14 uname">{post.who}</span>
              {post.verified && <Verified />}
              {isSub && !mine && (
                <span
                  className="tag"
                  style={{
                    padding: "1px 8px",
                    fontSize: 10.5,
                    color: "var(--blueL-ink)",
                    border: "none",
                  }}
                >
                  Subscribed
                </span>
              )}
            </div>
            <div className="muted t13">
              @{post.handle} · {formatTimeAgo(post.createdAt)}
            </div>
          </div>
        </div>
        <div className="row gap8">
          {!mine && <FollowBtn username={post.handle} />}
          <Menu items={menu} />
        </div>
      </div>

      {post.text && (
        <div
          className="t14"
          style={{ margin: "13px 0", lineHeight: 1.55 }}
          onClick={(e) => e.stopPropagation()}
        >
          <MentionText text={post.text} />
        </div>
      )}

      <div onClick={(e) => e.stopPropagation()}>
        {/* Locked = subscribers-only, per the feed doc — a subscribed viewer
         *  (isSub) sees it unlocked with no further action needed. The PPV
         *  "Unlock · N coins" path is a separate, still-local-only purchase
         *  flow this card already had — kept for whenever the backend
         *  actually sends a per-post price, but only shown when it does,
         *  since post.price is never fabricated when it's genuinely absent. */}
        {post.locked && !isSub && !isUnlocked ? (
          <div className="locked" style={{ height: LOCKED_H }}>
            <Photo
              sizes={SIZES.feedCard}
              src={post.media[0]?.url}
              blur={10}
              scale={1.12}
            />
            <div className="lockcover">
              <div
                className="feature-ic"
                style={{ background: "rgba(37,153,246,.16)" }}
              >
                <Icon n="lock" c="var(--blueL)" />
              </div>
              <div className="b7" style={{ color: "#fff" }}>
                Exclusive locked content
              </div>
              <div className="row gap8">
                <button
                  className="btn btn-ghost btn-sm"
                  disabled={subscribeMutation.isPending}
                  onClick={() => subscribeMutation.mutate({})}
                >
                  {subscribeMutation.isPending ? "Subscribing…" : "Subscribe"}
                </button>
                {post.price != null && (
                  <button
                    className="btn btn-blue btn-sm"
                    onClick={() => S.openModal("ppv", legacyPost(post, mine))}
                  >
                    Unlock · {post.price} coins
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ position: "relative" }}>
            <PostMedia media={post.media} />
            {post.locked && isUnlocked && !isSub && (
              <span
                className="chip-mint onart"
                style={{ position: "absolute", top: 10, left: 10, zIndex: 1 }}
              >
                <Icon n="check" s={12} />
                Unlocked
              </span>
            )}
          </div>
        )}

        {post.poll && (
          <div className="col gap8" style={{ marginBottom: 4, marginTop: 12 }}>
            {/* Voting view: time left sits above the options, like the old form. */}
            {!showPollResults && pollTimeLeft && (
              <div className="muted t12">{pollTimeLeft}</div>
            )}

            {post.poll.map((o, i) =>
              showPollResults ? (
                // ── Results: shown once you've voted, or the poll has ended ──
                <div
                  key={o.id || i}
                  className="hair"
                  style={{
                    position: "relative",
                    padding: "11px 14px",
                    borderRadius: 12,
                    overflow: "hidden",
                    borderColor:
                      post.pollVotedIndex === i
                        ? "var(--blue-ink)"
                        : "var(--line)",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: `${o.pct}%`,
                      background:
                        post.pollVotedIndex === i
                          ? "rgba(37,153,246,.3)"
                          : "rgba(37,153,246,.14)",
                    }}
                  />
                  <div className="row between" style={{ position: "relative" }}>
                    <span className="row gap8 b6 t14">
                      {post.pollVotedIndex === i && (
                        <Icon n="check" s={14} c="var(--blueL-ink)" />
                      )}
                      {o.label}
                    </span>
                    <span className="muted t13">{o.pct}%</span>
                  </div>
                </div>
              ) : (
                // ── Voting: pick an option, then press Vote ──
                <button
                  type="button"
                  key={o.id || i}
                  className="hair row gap10"
                  onClick={() => setSelectedChoice(o.id)}
                  style={{
                    padding: "11px 14px",
                    borderRadius: 12,
                    textAlign: "left",
                    borderColor:
                      selectedChoice === o.id
                        ? "var(--blue-ink)"
                        : "var(--line)",
                    background:
                      selectedChoice === o.id
                        ? "rgba(37,153,246,.1)"
                        : undefined,
                  }}
                >
                  <span
                    style={{
                      width: 16,
                      height: 16,
                      flex: "none",
                      borderRadius: "50%",
                      border: `2px solid ${selectedChoice === o.id ? "var(--blue-ink)" : "var(--line2)"}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {selectedChoice === o.id && (
                      <span
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: "var(--blue-ink)",
                        }}
                      />
                    )}
                  </span>
                  <span className="b6 t14">{o.label}</span>
                </button>
              ),
            )}

            {!showPollResults && (
              <button
                type="button"
                className="btn btn-blue btn-sm"
                style={{ alignSelf: "flex-start" }}
                disabled={!selectedChoice || isVoting}
                onClick={vote}
              >
                {isVoting ? "Voting…" : "Vote"}
              </button>
            )}

            {showPollResults && (
              <div className="muted t12">
                {post.pollTotalVotes.toLocaleString()}{" "}
                {post.pollTotalVotes === 1 ? "vote" : "votes"}
                {pollTimeLeft && ` · ${pollTimeLeft}`}
                {post.pollVotedIndex !== null && " · you voted"}
              </div>
            )}
          </div>
        )}
      </div>

      <div
        className="row between postbar"
        style={{ marginTop: 14 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="row gap20 postacts">
          <ReactionButton
            myReaction={post.myReaction}
            totalCount={post.counts.reactions}
            byReactionType={post.counts.byReactionType}
            onReact={(type: ReactionType) => react(type)}
            onRemove={removeReaction}
          />
          <button
            className="row gap6 muted"
            onClick={() =>
              variant === "detail"
                ? document
                    .getElementById("post-comments")
                    ?.scrollIntoView({ behavior: "smooth" })
                : setShowComments((v) => !v)
            }
            style={{
              color:
                variant === "feed" && showComments ? "var(--blueL-ink)" : "",
            }}
          >
            <Icon n="comment" s={19} />
            {post.counts.comments}
          </button>
        </div>
        {!mine && (
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => S.openModal("gift", creatorForModal(post))}
          >
            <Icon n="gift" s={15} />
            Gift
          </button>
        )}
      </div>

      {variant === "feed" && showComments && (
        <div
          style={{
            marginTop: 14,
            borderTop: "1px solid var(--line)",
            paddingTop: 12,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {post.comments.map((c) => (
            <div
              key={c.id}
              className="row gap10"
              style={{ padding: "7px 0", alignItems: "flex-start" }}
            >
              <Avatar name={c.who} src={c.avatar} size={30} initialsOnly />
              <div className="col">
                <span className="t13">
                  <b className="uname">{c.mine ? "You" : c.who}</b>
                </span>
                <span className="t14">
                  <MentionText text={c.text} />
                </span>
              </div>
            </div>
          ))}
          <CommentComposer onSubmit={addComment} />
        </div>
      )}

      {editing && (
        <EditPostDialog raw={raw} onClose={() => setEditing(false)} />
      )}

      {confirmDelete && (
        <ConfirmDialog
          title="Delete post"
          message="Are you sure you want to delete this post?"
          isPending={isDeleting}
          onConfirm={deletePost}
          onCancel={() => setConfirmDelete(false)}
        />
      )}
    </div>
  );
}
